<template>
  <figure :class="$style.container" @click="handleClick">
    <a v-if="slide.video" :class="[$style.imageContainer, $style.mediaLink]">
      <Play />
      <img :alt="slide.title" :src="slide.image" />
    </a>
    <a
      v-else
      :class="[$style.imageContainer, $style.mediaLink]"
      :href="slide.imageLink"
      :target="slide.newWindow ? '_blank' : '_self'"
    >
      <img :alt="slide.title" :src="slide.image" />
    </a>

    <figcaption>
      <a>
        <span :class="$style.title">{{ slide.title }}</span>
        <span :class="$style.text" v-html="slide.text" />
      </a>
    </figcaption>
  </figure>
</template>

<script setup>
import Play from '../../Play/Play.vue';

const props = defineProps({
  slide: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['openModal']);

const handleClick = () => {
  if (props.slide.video) {
    emit('openModal', props.slide.video, props.slide.isYouTube);
  }
};
</script>

<style module lang="scss">
@forward './CarouselSlide.scss';
</style>
